/**
 * Created by wangrun on 2017/7/5.
 */
import sidebarComponent from './sidebar.vue'
const ataSideBar = {
    install: function(Vue){
        Vue.component('ataSideBar',sidebarComponent)
    }
}
export default ataSideBar